import { render, staticRenderFns } from "./AppBarLogo.vue?vue&type=template&id=c0446c88&scoped=true&"
import script from "./AppBarLogo.vue?vue&type=script&lang=ts&"
export * from "./AppBarLogo.vue?vue&type=script&lang=ts&"
import style0 from "./AppBarLogo.vue?vue&type=style&index=0&id=c0446c88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0446c88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VImg,VRow})
